import type { Teacher, TeacherAssignment } from "@/types";

/* ------------------------------------------------------------------------- */
/* Contrat du formulaire (partagé entre la page et la fenêtre)              */
/* ------------------------------------------------------------------------- */

export interface TeacherFormState {
  cycleId: string;
  firstName: string;
  lastName: string;
  photo: string;
  gender: "M" | "F";
  phone: string;
  email: string;
  status: Teacher["status"];
  hireDate: string;
  /** Heures d'enseignement par semaine (saisi comme texte pour l'input). */
  weeklyHours: string;
  /** Tarif horaire en FG (saisi comme texte pour l'input). */
  hourlyRate: string;
  /** Primaire : « FIXED » paie le salaire fixe à la place du calcul au tarif horaire. */
  payMode: "HOURLY" | "FIXED";
  /** Salaire fixe mensuel (saisi comme texte pour l'input). */
  fixedMonthlySalary: string;
  primaryClassId: string;
  assignments: TeacherAssignment[];
  /** Compte de connexion lié (vide : aucun). */
  userId: string;
}

/** Formulaire vierge pour un cycle donné. */
export function createEmptyForm(cycleId: string): TeacherFormState {
  return {
    cycleId,
    firstName: "",
    lastName: "",
    photo: "",
    gender: "M",
    phone: "",
    email: "",
    status: "ACTIVE",
    hireDate: "2026-09-01",
    weeklyHours: "",
    hourlyRate: "",
    payMode: "HOURLY",
    fixedMonthlySalary: "",
    primaryClassId: "",
    assignments: [],
    userId: "",
  };
}

/** Convertit un enseignant existant en état de formulaire éditable. */
export function teacherToForm(teacher: Teacher): TeacherFormState {
  return {
    cycleId: teacher.cycleId,
    firstName: teacher.firstName,
    lastName: teacher.lastName,
    photo: teacher.photo ?? "",
    gender: teacher.gender,
    phone: teacher.phone,
    email: teacher.email,
    status: teacher.status,
    hireDate: teacher.hireDate,
    weeklyHours: teacher.weeklyHours ? String(teacher.weeklyHours) : "",
    hourlyRate: teacher.hourlyRate ? String(teacher.hourlyRate) : "",
    payMode: teacher.fixedMonthlySalary ? "FIXED" : "HOURLY",
    fixedMonthlySalary: teacher.fixedMonthlySalary ? String(teacher.fixedMonthlySalary) : "",
    primaryClassId: teacher.primaryClassId ?? "",
    userId: teacher.userId ?? "",
    assignments: (teacher.assignments ?? []).map((a) => ({
      classId: a.classId,
      subjectIds: [...a.subjectIds],
    })),
  };
}
